/// <summary>
/// This object provides js functions for project center <br/>
/// It implements a top menu with user-based menu points incl. additional admin menu settings<br/>
/// <br/>
/// Author: AFU<br />
/// Date: 17.10.2024<br />
/// Copyright ©: EUDT GmbH 2024 <br />
/// Version-History:<br />
/// **********************************************************************<br />
/// *** v1.0.0 - 11.11.2024                                              *<br />
/// **********************************************************************<br />
/// * - basic functionality                                              *<br />
/// **********************************************************************<br />
/// </summary>


jQuery.widget("bluaul.ProjectCenter", jQuery.common.vcBaseV4, {
    contentSize: { w: 0, h: 0 },
    userRights: null,
    _create: function () {
        this._createVisual(366);
        this._super();
    },

    _initHTML: function () {
        var me = this;
        try {
         
            me._setRoot(".project-center");
            //get user rights for specific menu handling
            me.userRights = JSON.parse(me.specific.userRights);
            me.specific.isAdmin = JSON.parse(me.specific.isAdmin);

            me._buildHtml();
            me._setHeightsAndWidths();
        } catch (e) { me._writeErr(e); return false;}
        return true;
    },

    _initEvents: function () {
        var me = this;
        try {
            //me.myData = { editor: "", list: null };
            me._initStructure();

            _VCMQ.addConsumer('local');
            _VCMQ.consume($("<div>"), 'local', function (e) { me._doEvents(e); });

            //fetch status informations
            me._fetch();

            //select first menu to show
            me._toggle(me.myHtml.menu.wrapper.find(".button-toggle-active"));
        } catch (e) { me._writeErr(e);return false; }
        return true;
    },

    _buildHtml: function () {
        /// <summary>
        /// This function builds the html structure only
        /// </summary>
        var me = this;
        try {
           
            //init the main html parts
            me.myHtml = {
                menu: {}, admin: {}, btnSettings: {}, content: {}};

            //add the settings button on the right corner - for admins only
            if (me.specific.isAdmin) {
                let btnSettings = me.myHtml.btnSettings;
                btnSettings.wrapper = ButtonMenu._setMenuGroup("", false);
                btnSettings.wrapper.append(ButtonMenu._setMenuHeader("", "Administrator"));
                btnSettings.btn = ButtonMenu._setSimpleButton("", [], "", $("<i>", { class: 'fa fa-cog' }), me.specific.resources.settings);
                btnSettings.wrapper.append(btnSettings.btn);
                btnSettings.wrapper.css("float", "right");

                me.myRoot.append(btnSettings.wrapper);
            }

           

            //add the main menu 
            let obj = me.myHtml.menu;
            obj.wrapper = me._setWrapper("", "menu user");
            obj.docuMenu = ButtonMenu._setMenuGroup("", true);
            obj.docuMenu.append(ButtonMenu._setMenuHeader("", me.specific.resources.overview));
            obj.docuMenu.append(ButtonMenu._setSimpleButton("", ["type", "project-info"], "button-toggle-active", $("<i>", { class: 'fa fa-book' }), me.specific.resources.documentation, false));
            if (me._hasUserRights("contacts")) { obj.docuMenu.append(ButtonMenu._setSimpleButton("", ["type", "contacts"], "", $("<i>", { class: 'fa fa-users' }), me.specific.resources.contacts, false)) };
            obj.btnAlarms = null; 
            if (me._hasUserRights("alarms")) {
                obj.btnAlarms = ButtonMenu._setSimpleButton("", ["type", "alarms"], "", $("<i>", { class: 'fa fa-bell' }), me.specific.resources.alarms, true, true);
                obj.docuMenu.append(obj.btnAlarms);
            };
            if (me._hasUserRights("topo")) { obj.docuMenu.append(ButtonMenu._setSimpleButton("", ["type", "topo"], "", $("<i>", { class: 'fa fa-diagram-project' }), me.specific.resources.topology, false)) };
            if (me._hasUserRights("project-status")) { obj.docuMenu.append(ButtonMenu._setSimpleButton("", ["type", "project-status"], "", $("<i>", { class: 'fa fa-circle-info' }), me.specific.resources.status, false)) };
            ButtonMenu._setWidth(obj.docuMenu);
            obj.wrapper.append(obj.docuMenu);

             //group activities
            obj.infoMenu = ButtonMenu._setMenuGroup("", true);
            obj.infoMenu.append(ButtonMenu._setMenuHeader("", me.specific.resources.activities));
            obj.btnTickets = null; 
            if (me._hasUserRights("tickets")) {
                obj.btnTickets = ButtonMenu._setSimpleButton("", ["type", "tickets"], "", $("<i>", { class: 'fa fa-ticket' }), me.specific.resources.tickets, true, true);
                obj.infoMenu.append(obj.btnTickets);
            };
            obj.btnActivities = null;
            if (me._hasUserRights("activities")) {
                obj.btnActivities = ButtonMenu._setSimpleButton("", ["type", "activities"], "", $("<i>", { class: 'fa fa-calendar-day' }), me.specific.resources.activities, true, true);
                obj.infoMenu.append(obj.btnActivities);
            };
            if (me._hasUserRights("interventions")) { obj.infoMenu.append(ButtonMenu._setSimpleButton("", ["type", "interventions"], "", $("<i>", { class: 'fa fa-calendar' }), me.specific.resources.interventions, false)) };
           
            ButtonMenu._setWidth(obj.infoMenu);
            obj.wrapper.append(obj.infoMenu);

            //group more
            obj.diverseMenu = ButtonMenu._setMenuGroup("", true);
            obj.diverseMenu.append(ButtonMenu._setMenuHeader("", me.specific.resources.more));
            if (me.specific.isAdmin) { obj.diverseMenu.append(ButtonMenu._setSimpleButton("", ["type", "unc"], "", $("<i>", { class: 'fa fa-message-captions' }), "Emails", false)) };
            if (me._hasUserRights("tags")) { obj.diverseMenu.append(ButtonMenu._setSimpleButton("", ["type", "tags"], "", $("<i>", { class: 'fa fa-tags' }), me.specific.resources.tags, false)) };
            if (me._hasUserRights("media")) { obj.diverseMenu.append(ButtonMenu._setSimpleButton("", ["type", "media"], "", $("<i>", { class: 'fa fa-files' }), me.specific.resources.media, false)) };
            if (me._hasUserRights("reports")) { obj.diverseMenu.append(ButtonMenu._setSimpleButton("", ["type", "reports"], "", $("<i>", { class: 'fa fa-file-excel' }), me.specific.resources.reports, false)) };

            ButtonMenu._setWidth(obj.diverseMenu);
            obj.wrapper.append(obj.diverseMenu);

            me.myRoot.append(me.myHtml.menu.wrapper);

            //add admin menu
            if (me.specific.isAdmin) {

             
                obj = me.myHtml.admin;
                obj.wrapper = me._setWrapper("", "menu admin");
                obj.umMenu = ButtonMenu._setMenuGroup("", true);
                obj.umMenu.append(ButtonMenu._setMenuHeader("", me.specific.resources.parameterSettings));
                obj.umMenu.append(ButtonMenu._setSimpleButton("", ["type", "unit-manager"], "", $("<i>", { class: 'fa fa-cogs' }), me.specific.resources.signals, false));
                obj.umMenu.append(ButtonMenu._setSimpleButton("", ["type", "hardware"], "", $("<i>", { class: 'fa fa-shredder' }), me.specific.resources.hardware, false));
                obj.umMenu.append(ButtonMenu._setSimpleButton("", ["type", "hr-edit"], "", $("<i>", { class: 'fa fa-clock-rotate-left' }), me.specific.resources.highresolution, false));
                obj.umMenu.append(ButtonMenu._setSimpleButton("", ["type", "units"], "", $("<i>", { class: 'fa fa-microchip' }), me.specific.resources.units, false));
                obj.umMenu.append(ButtonMenu._setSimpleButton("", ["type", "history"], "", $("<i>", { class: 'fa fa-rectangle-history' }), me.specific.resources.history, false));
                obj.btnDirty = ButtonMenu._setSimpleButton("", ["type", "dirty"], "", $("<i>", { class: 'fa fa-exchange-alt' }), "Config", true,true);
                obj.umMenu.append(obj.btnDirty);
                ButtonMenu._setWidth(obj.umMenu);
                obj.wrapper.append(obj.umMenu);


                obj.projectMenu = ButtonMenu._setMenuGroup("", true);
                obj.projectMenu.append(ButtonMenu._setMenuHeader("", me.specific.resources.projectManagement));
                obj.projectMenu.append(ButtonMenu._setSimpleButton("", ["type", "customer-edit"], "", $("<i>", { class: 'fa fa-user' }), me.specific.resources.customer, false));
                obj.projectMenu.append(ButtonMenu._setSimpleButton("", ["type", "project-edit"], "", $("<i>", { class: 'fa fa-building' }), me.specific.resources.project, false));
                obj.projectMenu.append(ButtonMenu._setSimpleButton("", ["type", "project-user"], "", $("<i>", { class: 'fa fa-address-book' }), me.specific.resources.users, false));
                obj.projectMenu.append(ButtonMenu._setSimpleButton("", ["type", "project-rights"], "", $("<i>", { class: 'fa fa-shield-check' }), me.specific.resources.rightsGroups, false));
                obj.projectMenu.append(ButtonMenu._setSimpleButton("", ["type", "location"], "", $("<i>", { class: 'fa fa-location-dot' }), me.specific.resources.location,false));
                ButtonMenu._setWidth(obj.projectMenu);
                obj.wrapper.append(obj.projectMenu);

                obj.moreMenu = ButtonMenu._setMenuGroup("", true);
                obj.moreMenu.append(ButtonMenu._setMenuHeader("", me.specific.resources.more));
                obj.moreMenu.append(ButtonMenu._setSimpleButton("", ["type", "price-assign"], "", $("<i>", { class: 'fa fa-money-bill-wave' }), me.specific.resources.priceManagement,true));
                obj.moreMenu.append(ButtonMenu._setSimpleButton("", ["type", "co2-assign"], "", $("<i>", { class: 'fa fa-leaf' }), me.specific.resources.c02Management,true));
                obj.moreMenu.append(ButtonMenu._setSimpleButton("", ["type", "user"], "", $("<i>", { class: 'fa fa-address-book' }), me.specific.resources.userManagement,true));
                obj.moreMenu.append(ButtonMenu._setSimpleButton("", ["type", "url-export"], "", $("<i>", { class: 'fa fa-share' }), me.specific.resources.urlExport,false));


                ButtonMenu._setWidth(obj.moreMenu);
                obj.wrapper.append(obj.moreMenu);
                obj.wrapper.hide();
                me.myRoot.append(me.myHtml.admin.wrapper);
            }

            me.myHtml.content.wrapper = me._setWrapper("", "content").html(me.getLoadingIcon());
            me.myRoot.append(me.myHtml.content.wrapper );


        } catch (e) {me._writeErr(e);return false;}
        return true;
    },

    _hasUserRights: function (type) {
        /// <summary>
        /// This function returns true if a user has rights for the given type
        /// </summary>
        var me = this;
        try {
            if (me.error) { return false; }
            return (me.userRights.indexOf(type) >=0) 
        } catch (e) { me._writeErr(e); return false;  }
    },

    _initStructure: function () {
        /// <summary>
        /// This function inits various events and handlers
        /// </summary>
        var me = this;
        try {
            if (me.error) { return false; }

            ////add button for new link
            me.myRoot.find(".menu .button-toggle").off("click").on("click", function (e) { me._toggle($(this)); });

            //add settings button for admins
            if (me.specific.isAdmin)   me.myHtml.btnSettings.btn.off("click").on("click", function (e) { me._toggleSettings(); });

        } catch (e) { me._writeErr(e); return false; }
        return true;
    },

    _doEvents: function (e) {
        /// <summary>
        /// This function fetches new states on varius event messages
        /// </summary>
        var me = this;
        try {

            switch (e.msg) {
                case "UPDATE_SIGNAL_STATE": me._fetch(); break;
                case "SIGNAL_ANALOG_DETAIL_CLOSE": me._fetch(); break;
                case "SIGNAL_DIGITAL_EDIT_CLOSE": me._fetch(); break;
                case "UNIT_REFRESH": me._fetch(); break;
                case "UNIT_COMMITTED": me._fetch(); break;
                case "RULE_CLOSE": me._fetch(); break;
                case "UNITHISTORY_COMMIT": me._fetch(); break;
                case "SAVE_EVENTID": me._fetch(); break; //alarm changed
                case "SAVE_ACTIVITYID": me._fetch(); break; //alarm changed
                case "ACTIVITY_COMMITED": me._fetch(); break; //alarm reading-state changed
                case "TICKETS_CHANGED": me._fetch(); break; //tickets changed

              default: break;
            }
      } catch (e) { me._writeErr(e); }
    },

    _toggle: function (obj) {
        /// <summary>
        /// This function toggles through the different menu items
        /// </summary>
        var me = this;
        try {
            if (me.error) { return false; }
           
            let type = obj.data("type");
            let caption = obj.data("label");
            me.myRoot.find(".menu .button-toggle").removeClass("button-toggle-active");
            obj.addClass("button-toggle-active");

            let content = me.myHtml.content.wrapper;
            let divPrefix = "div-project-center-";

            let container = me.getRandomIDContainerObj(divPrefix, true);
            content.html(container.obj);
            container.obj.html(me.getLoadingIcon());
            container.obj.width(me.contentSize.w).height(me.contentSize.h);


            switch (type) {
                case "project-info":
                    me.myHtml.content.wrapper.ProjectInfo({ invokeType: "addVisualBase", blid: me.settings.blid });
                    break;
                case "contacts":

                    //container.obj.css("overflow-y", "auto");
                    me._setContentHeader(content, container, caption);
                    me.vcV.addVisualBaseByName(divPrefix, 'VISUAL_MENU_TOGGLE_CONTACTS', container.random, getCurrentTimestamp(), container.obj.height(), me.contentSize.w, JSON.stringify({ 'LoggerID': me.settings.blid, 'FixedContentHeight': true }), "", 1);
                    break;

                case "tickets":
                    me._setContentHeader(content, container, caption);
                    me.vcV.addVisualBaseByName(divPrefix, 'VISUAL_MENU_TOGGLE_TICKET', container.random, getCurrentTimestamp(), container.obj.height(), me.contentSize.w, JSON.stringify({ 'LoggerID': me.settings.blid, 'FixedContentHeight': true,  'CurrentProjectOnly':true }), "", 1);
                    break;
                case "alarms":
                    me._setContentHeader(content, container, caption);
                    me.vcV.addVisualBaseByName(divPrefix, 'VISUAL_MENU_TOGGLE_ALARM', container.random, getCurrentTimestamp(), container.obj.height(), me.contentSize.w, JSON.stringify({ 'LoggerID': me.settings.blid, 'FixedContentHeight': true }), "", 1);
                    break;
                case "topo":
                    me._setContentHeader(content, container, caption);
                    me.vcV.addVisualBaseByName(divPrefix, 'VISUAL_MENU_TOGGLE_TOPO', container.random, getCurrentTimestamp(), container.obj.height(), me.contentSize.w, JSON.stringify({ 'LoggerID': me.settings.blid, 'FixedContentHeight': true }), "", 1);
                    break;

                case "project-status":
                    me._setContentHeader(content, container, caption);
                    me.vcV.addVisualBaseByName(divPrefix, 'WIDGET_LOGGEROVERVIEW', container.random, getCurrentTimestamp(), container.obj.height(), me.contentSize.w, JSON.stringify({ 'LoggerID': me.settings.blid }), "", 1);
                    break;

                case "activities":
                    me._setContentHeader(content, container, caption);
                    me.vcV.addVisualBaseByName(divPrefix, 'VISUAL_MENU_TOGGLE_ACTIVITY', container.random, getCurrentTimestamp(), container.obj.height(), me.contentSize.w, JSON.stringify({ 'LoggerID': me.settings.blid, 'DeviceID': me.specific.bdid, 'FixedContentHeight': true }), "", 1);
                    break;

                case "interventions":
                    me._setContentHeader(content, container, caption);
                    me.vcV.addVisualBaseByName(divPrefix, 'VISUAL_MENU_TOGGLE_EVENT', container.random, getCurrentTimestamp(), container.obj.height(), me.contentSize.w, JSON.stringify({ 'LoggerID': me.settings.blid,  'FixedContentHeight': true }), "", 1);
                    break;
                   
                case "unc":
                    me._setContentHeader(content, container, caption);
                    container.obj.UserNotificationCenter({ invokeType: "addVisualContent", parameter: { } });

                    break;
                case "tags":
                    me._setContentHeader(content, container, caption);
                    container.obj.vcTagManager({ LoggerId: me.settings.blid });
                    break;
                case "media":
                    me._setContentHeader(content, container, caption);
                    container.obj.DocsList({ invokeType: "addVisualContent", parameter: { LoggerId: me.settings.blid } });
                    break;
                case "reports":
                    me._setContentHeader(content, container, caption);
                    me.vcV.addVisualBaseByName(divPrefix, 'WIDGET_REPORT_GENERATION', container.random, getCurrentTimestamp(), container.obj.height()-35, me.contentSize.w, "", "", 1);
                    break;


                //ADMIN
                case "unit-manager":
                    me._setContentHeader(content, container, caption);
                    me.vcV.addVisualBaseByName(divPrefix, 'VISUAL_UNIT_ANALOG_EDITOR', container.random, getCurrentTimestamp(), container.obj.height(), me.contentSize.w, JSON.stringify({ LoggerID: me.settings.blid }), "", 1);
                    break;

                case "hardware":
                    me._setContentHeader(content, container, caption);
                    me.vcV.addVisualBaseByName(divPrefix, 'VISUAL_UNIT_MANAGEMENT', container.random, getCurrentTimestamp(), container.obj.height(), me.contentSize.w, JSON.stringify({ LoggerID: me.settings.blid }), "", 1);
                    break;

                case "topo-edit":
                    me._setContentHeader(content, container, caption);
                    me.vcV.addVisualBaseByName(divPrefix, 'VISUAL_SIGNAL_DEPENDENCY', container.random, getCurrentTimestamp(), container.obj.height()-14, me.contentSize.w, JSON.stringify({ LoggerID: me.settings.blid }), "", 1);
                    break;

                case "hr-edit":
                    me._setContentHeader(content, container, caption);
                    me.vcV.addVisualBaseByName(divPrefix, 'VISUAL_SIGNALANALOG_HR', container.random, getCurrentTimestamp(), container.obj.height()-22, me.contentSize.w, JSON.stringify({ LoggerID: me.settings.blid }), "", 1);
                    break;

                case "units":
                    me._setContentHeader(content, container, caption);
                    me.vcV.addVisualBaseByName(divPrefix, 'VISUAL_FORM_LOGGER_UNIT', container.random, getCurrentTimestamp(), container.obj.height(), me.contentSize.w, "true,false,false," + me.settings.blid, 'true', 1);
                    break;

                case "history":
                    me._setContentHeader(content, container, caption);
                    me.vcV.addVisualBaseByName(divPrefix, 'VISUAL_UNIT_HISTORY', container.random, getCurrentTimestamp(), container.obj.height(), me.contentSize.w, JSON.stringify({ LoggerID: me.settings.blid, ShowAllMyProjects:false }), "", 1);

                    break;

                case "dirty":
                    me._setContentHeader(content, container, caption);
                    me.vcV.addVisualBaseByName(divPrefix, 'VISUAL_UNIT_CONFIGCOMMIT', container.random, getCurrentTimestamp(), container.obj.height(), me.contentSize.w, JSON.stringify({ loggerid: me.settings.blid }), "", 1);
                    break;

                case "customer-edit":
                    me._setContentHeader(content, container, caption);
                    me.vcV.addVisualContentByName(divPrefix, 'WIDGET_PROJECT_CUSTOMERFORM', container.random, getCurrentTimestamp(), container.obj.height(), me.contentSize.w, "", JSON.stringify({ 'customerid': me.specific.pid }), 1);
                    break;

                case "project-edit":
                    me._setContentHeader(content, container, caption);
                    me.vcV.addVisualContentByName(divPrefix, 'WIDGET_PROJECT_PROJECTFORM', container.random, getCurrentTimestamp(), container.obj.height(), me.contentSize.w, "", JSON.stringify({ "newProject": false, 'loggerid': me.settings.blid, 'customerid': me.specific.pid }),  1);
                    break;

                case "project-user":
                    me._setContentHeader(content, container, caption);
                    me.vcV.addVisualBaseByName(divPrefix, 'VISUAL_MEMBERSHIP_ASSIGNMENT_USER2LOGGER', container.random, getCurrentTimestamp(), container.obj.height(), me.contentSize.w, JSON.stringify({ "AssID": me.settings.blid }), "", 1);
                    break;

                case "project-rights":
                    me._setContentHeader(content, container, caption);
                    me.vcV.addVisualBaseByName(divPrefix, 'VISUAL_MEMBERSHIP_ASSIGNMENT_GROUP2SINGLELOGGER', container.random, getCurrentTimestamp(), container.obj.height(), me.contentSize.w, JSON.stringify({ "AssID": me.settings.blid }), "", 1);
                    break;

                case "location":
                    me._setContentHeader(content, container, caption);
                    me.vcV.addVisualBaseByName(divPrefix, 'VISUAL_WIDGET_GEOCODING', container.random, getCurrentTimestamp(), container.obj.height(), me.contentSize.w, "2" + "," + me.specific.bdid, "", 1);
                    break;  
               
                case "price-assign":
                    me._setContentHeader(content, container, caption);
                    me.vcV.addVisualBaseByName(divPrefix, 'VISUAL_META_SIGNAL2META_PRICE', container.random, getCurrentTimestamp(), container.obj.height(), me.contentSize.w, JSON.stringify({ LoggerID: me.settings.blid }),"", 1);
                    break;

                case "co2-assign":
                    me._setContentHeader(content, container, caption);
                    me.vcV.addVisualBaseByName(divPrefix, 'VISUAL_META_SIGNAL2META_CO2', container.random, getCurrentTimestamp(), container.obj.height(), me.contentSize.w, JSON.stringify({ loggerid: me.settings.blid }), "", 1);
                    break;

                case "user":
                    me._setContentHeader(content, container, caption);
                    me.vcV.addVisualBaseByName(divPrefix, 'VISUAL_MEMBERSHIP_USERLIST', container.random, getCurrentTimestamp(), container.obj.height(), me.contentSize.w, JSON.stringify({ loggerid: me.settings.blid}), "", 1);

                    break;
                case "url-export":
                    me._setContentHeader(content, container, caption);
                    container.obj.UrlList({ invokeType: "addVisualBase", parameter: { LoggerId: me.settings.blid, CurrentProjectOnly:true } });
                    break;

                default:
            }


           
        } catch (e) { me._writeErr(e); return false; }
        return true;
    },

    _toggleSettings: function () {
        /// <summary>
        /// This function shows/hides the user vs admin menu
        /// </summary>
        var me = this;
        try {
            if (me.error) { return false; }

            let obj = me.myHtml.btnSettings.btn;
            let active = obj.hasClass("button-toggle-active");

            if (active) {
                obj.removeClass("button-toggle-active");
                me.myHtml.menu.wrapper.show();
                me.myHtml.admin.wrapper.hide();
                me._toggle(me.myHtml.menu.wrapper.find(".button-toggle:first"));
                return true;
            } else {
                obj.addClass("button-toggle-active");
                me.myHtml.menu.wrapper.hide();
                me.myHtml.admin.wrapper.show();
                me._toggle(me.myHtml.admin.wrapper.find(".button-toggle:first"));
                return true;
            }


        } catch (e) { me._writeErr(e); return false; }
        return true;
    },

    _setContentHeader: function (content,container, caption) {
        /// <summary>
        /// This function generates a header line for the given menu
        /// </summary>
        var me = this;
        try {
            if (me.error) { return false; }

            var header = me._setObj("content-header", "vc-list vc-grid-margin-bottom");
            var wrapper = me._setListHeader("");
            var line = me._setListItem();
            line.column.append(me._setListElement("", "").html(caption));
            header.append(wrapper.append(line.item));

            content.prepend(header);
            container.obj.height(me.contentSize.h - 9);
            return header;

        } catch (e) { me._writeErr(e); return ""; }
        return "";
    },

    _fetch: function () {
        /// <summary>
        /// This function fetches different status values and updates the info fields
        /// </summary>
        var me = this;
        try {
         
            me.getData({ TypeId: 1, Bdid: me.specific.bdid }, function (result) {

                //check response content
                if (result == null) {me.showMessage(me.resources.err_loadData, true);return true;}

                //console.info(result);
                    if (result.DirtyConfig === 0) {
                        me._setInfo(me.myHtml.admin.btnDirty, "OK", false);
                       
                    } else {
                        me._setInfo(me.myHtml.admin.btnDirty, "DIRTY", true);
                }
                me._setInfo(me.myHtml.menu.btnAlarms, "(" + result.OpenAlarms + ")", result.OpenAlarms !== 0);
                me._setInfo(me.myHtml.menu.btnTickets, "(" + result.OpenTickets + ")", result.OpenTickets !== 0);
                me._setInfo(me.myHtml.menu.btnActivities, "(" + result.OpenActivities + ")", result.OpenActivities !== 0);
              
            });

        } catch (e) { me._writeErr(e); return false; }
        return true;
    },
    _setInfo: function (obj, caption, isError) {
        /// <summary>
        /// This function writes a proper info 
        /// </summary>
        var me = this;
        try {
            if (obj != null) {
                let lbl = $("<div>").html(caption);
                if (isError) lbl.addClass("icon-color-error");
                obj.find(".info-line").html(lbl);
            }
        } catch (e) { me._writeErr(e);  }
    },

    _setHeightsAndWidths: function () {
        /// <summary>
        /// This function calculates and sets the height of elements relatively to the general content height
        /// </summary>
        var me = this;
        try {
            if (me.error) { return false; }

            var h = parseInt(me._getVisualHeight() - parseInt(me.myHtml.menu.wrapper.outerHeight())-14);

            me.myHtml.content.wrapper.height(h);
            me.contentSize.h = h;
            me.contentSize.w = parseInt(me.myHtml.content.wrapper.width()-1);

        } catch (e) { me._writeErr(e); return false; }
        return true;
    },

    specificInfoHandling: function (bError) {
        /// <summary>
        /// This function handles error states - it hides specific objects on error message
        /// </summary>
        var me = this;
        try {
            if (bError) {
                me.myHtml.menu.wrapper.hide();
                me.myHtml.admin.wrapper.hide();
                me.myHtml.btnSettings.wrapper.hide();
                me.myHtml.content.wrapper.hide();
            }
           
        } catch (e) { me._writeErr(e); return false;}
        return true;
    }
});